export default __webpack_public_path__ + "static/media/matthew_nebiyou.776ceec8.jpeg";